export interface ApiErrorEvent {
  status?: number;
  url: string;
  message: string;
}

const target = new EventTarget();
const EVENT = 'api-error';

export function notifyApiError(detail: ApiErrorEvent): void {
  target.dispatchEvent(new CustomEvent<ApiErrorEvent>(EVENT, {detail}));
}

export function subscribeToApiErrors(
  handler: (detail: ApiErrorEvent) => void
): () => void {
  const listener = (e: Event) =>
    handler((e as CustomEvent<ApiErrorEvent>).detail);
  target.addEventListener(EVENT, listener);
  return () => target.removeEventListener(EVENT, listener);
}
